/* ki-free-shipping.js — strip redundant "Shipping calculated at checkout" */
(function () {
  function kiStripShipCalc() {
    try {
      document.querySelectorAll(".product__policies").forEach(function (el) {
        if (el.querySelector("shopify-payment-terms")) return;
        var t = (el.textContent || "");
        if (/calculated at checkout/i.test(t) || (/shipping/i.test(t) && /checkout/i.test(t))) {
          var tax = t.match(/tax included\.?/i);
          if (tax) el.innerHTML = tax[0];
          else el.remove();
        }
      });
      document.querySelectorAll("small").forEach(function (el) {
        if (/calculated at checkout/i.test(el.textContent || "")) {
          var row = el.closest(".cart__item-row") || el;
          row.style.display = "none";
        }
      });
    } catch (e) {}
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", kiStripShipCalc);
  else kiStripShipCalc();
  document.addEventListener("shopify:section:load", kiStripShipCalc);
  setTimeout(kiStripShipCalc, 200);
  setTimeout(kiStripShipCalc, 800);
  setTimeout(kiStripShipCalc, 2000);
})();
